module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"logged_in_banner":{"partner_teaser":"Partner des Monats"}}}}}}')
  delete Component.options._Ctor
}
